var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_6264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 12.2617C21.5999 11.4563 21.5345 10.8685 21.3931 10.259H12.1958V13.8944H17.5944C17.4856 14.7978 16.8978 16.1583 15.5917 17.0726L15.5734 17.1943L18.4814 19.4471L18.6829 19.4672C20.5332 17.7583 21.5999 15.244 21.5999 12.2617Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1959 21.84C14.8407 21.84 17.0611 20.9692 18.6829 19.4672L15.5918 17.0726C14.7646 17.6494 13.6543 18.0522 12.1959 18.0522C9.60541 18.0522 7.40679 16.3434 6.62304 13.9815L6.50816 13.9912L3.48437 16.3314L3.44482 16.4413C5.05569 19.6413 8.36454 21.84 12.1959 21.84Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62299 13.9815C6.41619 13.372 6.29651 12.7188 6.29651 12.044C6.29651 11.3692 6.41619 10.7161 6.61211 10.1066L6.60663 9.97681L3.54495 7.59908L3.44478 7.64673C2.78086 8.97464 2.3999 10.4658 2.3999 12.044C2.3999 13.6223 2.78086 15.1134 3.44478 16.4413L6.62299 13.9815Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1959 6.03586C14.0353 6.03586 15.2761 6.83041 15.9836 7.49441L18.7482 4.79507C17.0503 3.21684 14.8407 2.24813 12.1959 2.24813C8.36454 2.24813 5.05569 4.44675 3.44482 7.64673L6.61216 10.1066C7.40679 7.74473 9.60541 6.03586 12.1959 6.03586Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_6264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.648,
    fill: "white",
    transform: "translate(2.3999 2.22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.b442af8b220f631ebfb9975a08f825fb.svg";
export { ForwardRef as ReactComponent };